import { computed, ref } from 'vue';
import {
    ICoachingFormTableItem,
    ResponseGetCoachingFormTable,
} from '../services/api/coachingForm/types';
import { defineStore } from 'pinia';
import { useQueryParam, useQueryString } from '../composables/useQueryString';

export type CoachingFormTableColumn = {
    field: 'title' | 'useAi' | 'createdAt' | 'createdBy' | 'updatedBy' | 'actions';
    name: string;
    sortable?: boolean;
};

function filterForms(
    forms: ICoachingFormTableItem[],
    sortDirection: string | null,
    searchTerm: string | null
): ICoachingFormTableItem[] {
    let filteredForms = [...forms];

    if (searchTerm) {
        const term = searchTerm.toLowerCase();
        filteredForms = filteredForms.filter((form) => form.title.toLowerCase().includes(term));
    }

    filteredForms.sort((a, b) => {
        if (a.title < b.title) return sortDirection === 'asc' ? -1 : 1;
        if (a.title > b.title) return sortDirection === 'asc' ? 1 : -1;
        return 0;
    });

    return filteredForms;
}

export const useCoachingFormTableData = defineStore('coachingFormTableData', () => {
    const forms = ref<ICoachingFormTableItem[]>([]);
    const querystring = useQueryString();

    const { value: sortDirection } = useQueryParam('sortDirection', {
        defaultValue: '',
        updateMode: 'replace',
    });
    const { value: showInactive } = useQueryParam('showInactive', {
        defaultValue: '',
        updateMode: 'replace',
    });
    const { value: search } = useQueryParam('search', {
        defaultValue: '',
        updateMode: 'replace',
    });

    const formData = computed<ICoachingFormTableItem[]>(() => {
        return filterForms(forms.value, sortDirection.value, search.value);
    });

    const setForms = (data: ResponseGetCoachingFormTable) => {
        forms.value = data.forms;
    };

    const changeFilter = async (key: string, value: string) => {
        await querystring.set(key, value);
    };

    return { formData, setForms, changeFilter, search, showInactive, sortDirection };
});
